// Components
import { SelectOptionProps } from "components/atoms/Select";

// Types
import { BankDataResponse } from "types/PaymentMethodsTypes";

export const mapBanksB2F = (data: BankDataResponse[]): SelectOptionProps[] => {
  return data
    .filter((b) => !!b.is_active)
    .map((b) => ({
      id: b.id,
      name: b.name,
      image: b.logo,
    }));
};
